export const sendNotificationEmail =
  "https://us-central1-easy-budgets-dev.cloudfunctions.net/emailNotification";
